import { DisconnectOutlineIcon } from "@tandemdiabetes/sugarmate-react-components"
import { useMemo } from "react"
import { HeaderDisplayState } from "./HeaderDisplayState"
import styles from "./HeaderError.module.scss"
import { usePolyglot } from "src/contexts"

const polyglotPrefix = "pages.home.user_header."

interface Props {
  displayState:
    | HeaderDisplayState.NoCGMData
    | HeaderDisplayState.NoCGMSession
    | HeaderDisplayState.NoDataSource
    | HeaderDisplayState.NoPumpOrCGMData;
}

export function HeaderError(props: Props) {
  const { displayState } = props
  const polyglot = usePolyglot()

  const localizationKey = useMemo(
    () => {
      if (displayState === HeaderDisplayState.NoCGMSession) {
        return `${polyglotPrefix}no_cgm_session_message`
      }

      if (displayState === HeaderDisplayState.NoDataSource) {
        return `${polyglotPrefix}no_data_source_message`
      }

      if (displayState === HeaderDisplayState.NoPumpOrCGMData) {
        return `${polyglotPrefix}no_pump_or_data_message`
      }

      return `${polyglotPrefix}no_data_message`
    },
    [displayState],
  )

  return (
    <div className={styles.errorContainer}>
      <DisconnectOutlineIcon className={styles.errorIcon} />
      <div
        id="no-data-message"
        className={styles.errorText}
      >
        {polyglot.t(localizationKey)}
      </div>
    </div>
  )
}
